import { $api } from "./axios.service";

export class PromocodeService {
  static getPromocodesByPage(values) {
    return $api.post("/api/front/promoCode/all", values);
  }
}
